<div style="margin: 10px 10px 10px 10px;">

  <div class="form-group row mb-3">
    <div class="uv-row">
      <span class="col-lg-3">&nbsp;</span>
      <span class="col-lg-2">Campus:</span>
      <div class="col-lg-3">
        <select class="form-control" [formControl]="campusName" (change)="onCampusChanged()">
          @for (cName of campusNames; track cName) {
            <option value="{{cName}}">{{cName}}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="form-group row mb-3">
    <div class="uv-row">
      <span class="col-lg-3">&nbsp;</span>
      <span class="col-lg-2">Building:</span>
      <div class="col-lg-3">
        <select class="form-control" [formControl]="buildingName" (change)="onBuildingChanged()" >
          @for (bName of buildingNames; track bName) {
            <option value="{{bName}}">{{bName}}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="form-group row mb-3">
    <div class="uv-row">
      <span class="col-lg-3">&nbsp;</span>
      <span class="col-lg-2">Room:</span>
      <div class="col-lg-3">
        <select class="form-control" [formControl]="roomName">
          @for (rName of roomNames; track rName) {
            <option value="{{rName}}">{{rName}}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="uv-row">
      <span class="col-lg-3">&nbsp;</span>
      <span class="col-lg-2">&nbsp;</span>
      <div class="col-lg-3" style="height: 60px; display: flex; justify-content: center; align-items: center;">
        <button [disabled]="!enableLookup" type="button" pButton label="Lookup" (click)="lookup()"></button>
      </div>
    </div>
  </div>


  <div class="form-group row" style="margin-top: 30px;">
    <fieldset>
      <legend>Room / Jacks</legend>
    </fieldset>
  </div>

  <div class="form-group row">

    <div class="uv-row">
      <p-table #table class="s2j-table" [value]="entries" compareSelectionBy="equals"
        [resizableColumns]="true" dataKey="dataKey"
        [scrollable]="true" [scrollHeight]="ifTableHeight"
        [customSort]="true" (sortFunction)="doCustomSort($event)"
        (onFilter)="onFilterChange()" [(first)]="first">
        <ng-template pTemplate="header">
          <tr>
            @for (col of cols; track col) {
              <th pResizableColumn [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            }
          </tr>
          <tr>
            @for (col of cols; track col) {
              <th>
                <input #filter pInputText type="text" style="width: 100%;"
                  (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
              @for (col of cols; track col) {
                <td>
                  <span class="uv-table-value">{{rowData[col.field]}}</span>
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>

    </div>

  </div>
